"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

exports.__esModule = true;
exports.normalize = void 0;

var convert_1 = require("@shootismoke/convert");

var E = __importStar(require("fp-ts/lib/Either"));

var pipeable_1 = require("fp-ts/lib/pipeable");

var util_1 = require("../../util");
/**
 * Normalize aqicn byGps data
 *
 * @param data - The data to normalize
 */


function normalize(_a) {
  var _b = __read(_a.d, 1),
      data = _b[0];

  var stationId = "waqi|" + data.x;

  if (!convert_1.isPollutant(data.pol)) {
    return E.left(util_1.providerError('waqi', "Cannot normalize station " + stationId + ", unrecognized pollutant " + data.pol + ": " + JSON.stringify(data)));
  }

  var aqiUS = +data.v; // Calculate pm25 raw value to get cigarettes value

  var raw = convert_1.convert('pm25', 'usaEpa', 'raw', aqiUS);

  if (!data.u.includes('/')) {
    return E.left(util_1.providerError('waqi', "Got invalid country/city info: " + JSON.stringify(data.u)));
  }

  var _c = __read(data.u.split('/'), 2),
      countryRaw = _c[0],
      city = _c[1]; // Get UTC time


  var utc = new Date(+data.t * 1000).toISOString();
  return pipeable_1.pipe(util_1.getCountryCode(countryRaw), E.fromOption(function () {
    return util_1.providerError('waqi', "Cannot get code from country " + countryRaw);
  }), E.map(function (country) {
    return [{
      attribution: [{
        name: data.nlo
      }],
      averagingPeriod: {
        unit: 'day',
        value: 1
      },
      coordinates: {
        latitude: data.geo[0],
        longitude: data.geo[1]
      },
      country: country,
      city: city,
      date: {
        local: utc,
        utc: utc
      },
      location: "waqi|" + data.x,
      mobile: false,
      parameter: data.pol,
      sourceName: 'waqi',
      sourceType: 'other',
      unit: convert_1.getPollutantMeta(data.pol).preferredUnit,
      value: raw
    }];
  }));
}

exports.normalize = normalize;